import type { UpcomingInvoicesReportItem } from '@vy/types';
import { caseInsensitiveIncludes } from '@vy/utils';

export function applyBillingForecastSearch(
  reportItems: UpcomingInvoicesReportItem[],
  searchText: string | null | undefined,
): UpcomingInvoicesReportItem[] {
  const normalized = searchText?.trim();

  if (!normalized) {
    return reportItems;
  }

  return reportItems.filter((item) => {
    if (caseInsensitiveIncludes(item.customer.name, normalized)) {
      return true;
    }

    return item.invoices.some((invoice) => caseInsensitiveIncludes(invoice.name, normalized));
  });
}
